module.exports = __webpack_public_path__ + "static/01-821b3bc6d15e46243448af1f9d607e00.jpg";